module.exports = __webpack_public_path__ + "static/media/benefit-star.05401297.svg";